<template>
  <div>
    <ots-main-title :mainTopBtn="mainTopBtnList" />
    <div class="topTip">
      <span class="f18 col_black mr20">{{StudentPlanName}}批次{{planInfo.name}}
      </span>
      <span>{{ `考试时间：${planInfo.beginTime}至${planInfo.endTime}` }}</span>
    </div>
    <div class="searchBox">
      <ots-refer
        class="mb20"
        :selectList="selectList"
        :request-form="stuSelectParams"
        @search="getStuList"
      />
    </div>
    <!-- <div class="mainCon"> -->
      <ots-table-group-new
        :tableHeader="tableHeader"
        :tableData="tableData"
        @handleSelectionChange="bachOper"
        :pagination="pagination"
        @changeNum="changeSize"
        @changePage="changePage"
      ></ots-table-group-new>
    <!-- </div> -->
    <!-- 导出 -->
    <ots-custom-dialog :dialog.sync="exportDialog" title="导出设置" width="40%">
      <template v-slot:content>
        <div>
          <el-form ref="form" :model="exportForm">
            <el-form-item label="请选择数据范围">
              <el-radio-group v-model="exportForm.exportType">
                <el-radio-button label="1">全部数据</el-radio-button>
                <el-radio-button label="2">查询结果数据</el-radio-button>
                <!-- <el-radio-button label=3>选中数据</el-radio-button> -->
              </el-radio-group>
            </el-form-item>
          </el-form>
        </div>
      </template>
      <template v-slot:footer>
        <el-button round @click="exportDialog = false">取消</el-button>
        <el-button round type="primary" @click="rightExport">确定</el-button>
      </template>
    </ots-custom-dialog>
    <!-- 查看考生 -->
    <ots-custom-dialog :dialog.sync="checkDialog" title="查看考生" width="50%">
      <template v-slot:content>
        <div>
          <div class="msgBox">
            <span>场次</span>{{ studentInfo.sessionName }}
          </div>
          <div class="msgBox"><span>教室</span>{{ studentInfo.className }}</div>
          <div class="msgBox"><span>座位号</span>{{ studentInfo.seatNo }}</div>
          <div class="msgBox">
            <span>准考证号</span>{{ studentInfo.entranceCode }}
          </div>
          <div class="msgBox"><span>姓名</span>{{ studentInfo.realName }}</div>
          <div class="msgBox">
            <span>身份证号码</span>{{ studentInfo.cardNo }}
          </div>
          <div class="msgBox">
            <span>考试批次</span>{{ studentInfo.planName }}
          </div>
          <div class="msgBox">
            <span>课程</span>{{ studentInfo.courseName }}
          </div>
          <div class="msgBox">
            <span>考试时间</span
            >{{ `${studentInfo.beginTime} 至 ${studentInfo.endTime}` }}
          </div>
        </div>
      </template>
      <template v-slot:footer>
        <el-button round type="primary" @click="checkDialog = false">关闭</el-button>
      </template>
    </ots-custom-dialog>

    <!-- 补时 -->
    <ots-custom-dialog :dialog.sync="suppleDialog" title="补时活动" width="50%">
      <template v-slot:content>
        <div>
          <div class="supple">
            <span>学生姓名<span class="dit">*</span>：</span>
            <span class="text">{{ suppleInfo.realName }}</span>
          </div>
          <div class="supple">
            <span>补时<span class="dit">*</span>：</span>
            <!-- <span class="text">{{ suppleInfo.realName }}</span> -->
            <el-input 
              style="margin-right: 8px;"
              placeholder="请输入补时时长（分钟）"
              v-model.number="minutes"
              type="number"
              class="suppleInput"
            ></el-input>
            <span>分钟</span>
          </div>
        </div>
      </template>
      <template v-slot:footer>
        <el-button round @click="suppleDialog = false">关闭</el-button>
        <el-button round type="primary" @click="addSupple">确定</el-button>
      </template>
    </ots-custom-dialog>

  </div>
</template>
<script>
import {
  getClassStudentListFn,
  exportStudentFn,
  getStudentViewInfoFn,
} from "@/http/modules/examSet/planClass";
import { getPlanSite,getCourseListBySessionList, addTimeSingleAPI } from "@/http/modules/examSet/section";
import { RegisterForm,trancePrint} from "@/http/modules/examSet/examBatch";
import pdf from "vue-pdf";
export default {
  components:{
    pdf
  },
  name: "student",
  data() {
    return {
      // 补时弹窗
      suppleDialog: false,
      // 补时时长
      minutes: '',

      StudentPlanName:'',
      exportDialog: false,
      checkDialog: false,
      planInfo: {},
      studentInfo: {},
      userInfo:'',
      mainTopBtnList: [
        {
          title: "导出",
          fn: this.exportStudent,
        },
      ],
      selectList: [
        {
          title: "考点",
          type: "select",
          requestKey: "placeId",
          label: "name",
          value: "id",
          data: [],
        },
        {
          title: "教室",
          type: "select",
          requestKey: "classId",
          label: "name",
          value: "id",
          data: [],
        },
        {
          title:'报考课程',
          type:'select',
          requestKey:'courseId',
          label:'courseName',
          value:'courseId',
        },
        {
          title:'签到状态',
          type:'select',
          requestKey:'signState',
          label:'name',
          value:'signState',
          data:[
            {signState:'2',name:'未签到'},
            {signState:'1',name:'签到通过'},
            {signState:'0',name:'签到未通过'},
          ]
        },
        {
          title: "答卷状态",
          type: "select",
          requestKey: "examStateId",
          label: "name",
          value: "id",
          data: [
            {id: 0, name: '全部'},
            {id: 1, name: '未开始'},
            {id: 2, name: '进行中'},
            {id: 3, name: '已结束'},
          ]
        },
        {
          title: "关键词",
          type: "input",
          placeholder: "姓名/准考证/证件号",
          requestKey: "searchKey",
        },
      ],
      stuSelectParams: {
        placeId: "",
        examStateId: "",
        classId: "",
        searchKey: "",
      },
      tableHeader: [
        {
          title: "姓名",
          prop: "realName",
        },
        {
          title: "准考证号",
          prop: "entranceCode",
        },
        {
          title: "证件号",
          prop: "cardNo",
        },
        {
          title: "考点",
          prop: "placeName",
        },
        {
          title: "教室",
          prop: "className",
        },
        {
          title: "座位号",
          prop: "seatNo",
        },
        {
          title:'签到状态',
          prop:'signState'
        },
        {
          title: "考试课程",
          prop: "courseName",
        },
        {
          title: "答卷状态",
          prop: "examStateName",
        },
        {
          title: "操作",
          type: "buttons",
          width: "240",
          btnList: [
            {
              title: "补时",
              formatter: (scope) => {
                return scope.row.examStateId == "3" || scope.row.examStateId == "1"
              },
              click: this.suppleTime,
            },
            {
              title: "查看详情",
              click: this.checkStudent,
            },
            {
              title:"准考证下载",
              click:this.downloadFiles
            }
          ],
        },
      ],
      tableData: [],
      tableOption: {
        multiple: true,
      },
      pagination: {
        total: 0,
      },
      courseId:'',
      stuListParams: {
        stuListParams:"",
        planId: "",
        page: 1,
        size: 10,
      },
      exportForm: {
        exportType: 1, //1 全部 2 查询结果数据 3选中数据
      },
      selectIds: [],
      suppleInfo: {},
    };
  },
  watch: {
    "stuSelectParams.placeId": function(val) {
      this.stuSelectParams.classId = "";
      this.selectList[1].data = this.selectList[0].data.filter(
        (item) => item.id == val
      )[0].placeClassList;
    },
  },
  created() {
    this.StudentPlanName = this.$route.query.planName
    this.initData();
    this.getCourseListBySession()
  },
  methods: {
    /**
     * @param { 补时 }
     */
    suppleTime(row) {
      this.suppleInfo = {
        realName: row.realName,
        studentCourseId: row.studentCourseId
      }
      this.minutes = ''
      this.suppleDialog = true
    },

    /**
     * @param { 执行补时 }
     */
    async addSupple() {
      if (this.minutes < 1 || this.minutes%1 != 0) {
        this.$message.warning("请输入补时数值！")
        return
      }
      let param = {
        studentCourseId: this.suppleInfo.studentCourseId,
        minutes: this.minutes
      }
      const { code } = await addTimeSingleAPI(param)
      if (code) this.$message.success("补时成功！")
      this.suppleDialog = false
    },






    bachOper(val) {
      let idList = [];
      val.forEach((item) => {
        idList.push(item.studentCourseId);
      });
      this.selectIds = idList;
    },
    async initData() {
      let planInfo = JSON.parse(window.localStorage.getItem("checkPlan"));
      this.planInfo = planInfo;
      this.stuListParams.planId = planInfo.planId;

      const { data } = await getPlanSite({ planId: planInfo.planId });
      this.selectList[0].data = data;

      // 场次ID
      this.stuListParams.sessionId = this.$route.query.sessionId;
      //
      // const {suerInfodata} = await selectUserInfo();
      // this.userInfo = suerInfodata
      // console.log(this.userInfo,'++++**---')
      this.getStuList();
    },
    changeSize(num) {
      this.stuListParams.size = num;
      this.getStuList();
    },
    changePage(p) {
      this.stuListParams.page = p;
      this.getStuList(true);
    },
    async getCourseListBySession(){
      const {data} = await getCourseListBySessionList({sessionId:this.$route.query.sessionId})
      let newSchoolList = [{courseId:'',courseName:'全部'},...data]
      this.$set(this.selectList[2],'data',newSchoolList)
    },
    
    async getStuList(page) {
      let params;
      if (!page) {
        this.stuListParams.page = 1;
        params = Object.assign(this.stuListParams, this.stuSelectParams);
      } else {
        params = Object.assign(this.stuTempParams, {
          page: this.stuListParams.page,
        });
      }

      const { data } = await getClassStudentListFn(params);
      this.stuTempParams = params;
      this.tableData = data.records;
     
      this.pagination.total = data.total;
    },
    exportStudent() {
      this.exportDialog = true;
    },
    async rightExport() {
      let params = this.exportForm;
      params.planId = this.planInfo.planId;
      params.sessionId = this.$route.query.sessionId;
 
      if (params.exportType == 1) {
        console.log(params)
      } else if (params.exportType == 2) {
        params.courseId = this.courseId
        console.log(params)
        params = Object.assign(params, this.stuSelectParams);
      } else if (params.exportType == 3) {
        if (!this.selectIds.length) {
          this.$message.error("请选择要导出的学生");
          return false;
        }
        params.studentCourseIds = this.selectIds.join();
      }
      const { code, data } = await exportStudentFn(params);
      if (code == 1) {
        window.open(data);
        this.exportDialog = false;
      }
    },
    async checkStudent(row) {//产看详情
      const { data } = await getStudentViewInfoFn({
        studentCourseId: row.studentCourseId,
      });
      this.studentInfo = data;
      this.checkDialog = true;
    },
    async downloadFiles(row){
      let param = {
        planId:this.stuListParams.planId,
        cardNo:row.cardNo
      }
      const {data} = await trancePrint(param)
      if(data){
        window.open(data)
      }
    }
  },
};
</script>
<style lang="less" scoped>
.topTip {
  height: 60px;
  display: flex;
  align-items: center;
  background-color: #ebf0fa;
  border-radius: 8px 8px 0 0;
  padding: 20px;
  box-sizing: border-box;
}
.mainCon {
  padding: 20px;
  border-radius: 8px;
  background-color: #fff;
  flex: 1;
}
.searchBox {
  background-color: #fff;
  border-radius: 0 0 8px 8px;
}
.msgBox {
  font-size: 14px;
  line-height: 2;
  color: #272e40;
  span {
    display: inline-block;
    width: 100px;
    color: #737780;
    margin-right: 10px;
  }
}

.supple {
  font-size: 14px;
  color: #272e40;
  margin-bottom: 16px;
  span:first-child {
    display: inline-block;
    width: 90px;
    color: #737780;
    margin-right: 10px;
    text-align: right;
    .dit {
      width: auto;
      color: #fe5958,
    }
  }
  /deep/ .el-input__inner {
    line-height: 1px !important;
  }
}

//suppleInput
/deep/.suppleInput input::-webkit-outer-spin-button,
/deep/.suppleInput input::-webkit-inner-spin-button {
  -webkit-appearance: none!important;
}

</style>
